export enum VentilatorConstants {
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'ventilator/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'ventilator/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  SET_VENTILATOR_CHECK = 'ventilator/SET_VENTILATOR_CHECK',
  SET_MODE = 'ventilator/SET_MODE',
  SET_BREATH_TYPE = 'ventilator/SET_BREATH_TYPE',
  SET_SETTINGS_RESP_RATE = 'ventilator/SET_SETTINGS_RESP_RATE',
  SET_TIDAL_VOLUME = 'ventilator/SET_TIDAL_VOLUME',
  SET_INSP_PRESSURE = 'ventilator/SET_INSP_PRESSURE',
  SET_PEEP = 'ventilator/SET_PEEP',
  SET_FIO2 = 'ventilator/SET_FIO2',
  SET_AIR_TEMPERATURE = 'ventilator/SET_AIR_TEMPERATURE',
  SET_AIR_TEMPERATURE_UNIT = 'ventilator/SET_AIR_TEMPERATURE_UNIT',
  SET_AIR_TEMPERATURE_UNIT_TEMP = 'ventilator/SET_AIR_TEMPERATURE_UNIT_TEMP',
  SET_HUMIDITY_AIR = 'ventilator/SET_HUMIDITY_AIR',
  SET_I_TIME = 'ventilator/SET_I_TIME',
  SET_PRESSURE_SUPPORT = 'ventilator/SET_PRESSURE_SUPPORT',
  SET_FLOW_RATE = 'ventilator/SET_FLOW_RATE',
  SET_SENSITIVITY = 'ventilator/SET_SENSITIVITY',
  SET_MEAN_AIRWAY_PRESSURE = 'ventilator/SET_MEAN_AIRWAY_PRESSURE',
  SET_DELTA_P = 'ventilator/SET_DELTA_P',
  SET_HERTZ = 'ventilator/SET_HERTZ',
  SET_INO = 'ventilator/SET_INO',
  SET_PEAK_INSP_PRESSURE = 'ventilator/SET_PEAK_INSP_PRESSURE',
  SET_PLATEAU_PRESSURE = 'ventilator/SET_PLATEAU_PRESSURE',
  SET_AUTO_PEEP = 'ventilator/SET_AUTO_PEEP',
  SET_MINUTE_VENT = 'ventilator/SET_MINUTE_VENT',
  SET_I_E_RATIO = 'ventilator/SET_I_E_RATIO',
  SET_MEASUREMENT_RESP_RATE = 'ventilator/SET_MEASUREMENT_RESP_RATE',
  SET_EXHALED_TIDAL_VOLUME = 'ventilator/SET_EXHALED_TIDAL_VOLUME',
  SET_ET_CUFF_PRESSURE_MEASUREMENT = 'ventilator/SET_ET_CUFF_PRESSURE_MEASUREMENT',
  SET_INSPIRATORY_RESISTANCE = 'ventilator/SET_INSPIRATORY_RESISTANCE',
  SET_STATIC_COMPLIANCE = 'ventilator/SET_STATIC_COMPLIANCE',
  SET_EXPIRATORY_TIME_CONSTANT = 'ventilator/SET_EXPIRATORY_TIME_CONSTANT',
  SET_ACTION = 'ventilator/SET_ACTION',
  SET_RESPONSE = 'ventilator/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'ventilator/SET_RESPONSE_PNNV',
  SAVE_VENTILATOR = 'ventilator/SAVE_VENTILATOR',
  RESET_STATE = 'ventilator/RESET_STATE',
  SET_ADD_TO_TIMELINE = 'ventilator/SET_ADD_TO_TIMELINE',
  SET_STATE = 'ventilator/SET_STATE',
  SET_DATE_TIME = 'ventilator/SET_DATE_TIME',
  SET_PTA = 'ventilator/SET_PTA',
  SET_ASSESSED_BY = 'ventilator/SET_ASSESSED_BY',
  ON_SELECT_VENTILATOR = 'ventilator/ON_SELECT_VENTILATOR',
  SET_UPDATE_INPUT_ROWS = 'ventilator/SET_UPDATE_INPUT_ROWS',
  SET_DATE = 'ventilator/SET_DATE',
  SET_TIME = 'ventilator/SET_TIME',
  SET_PROCEDURE_COMPLICATIONS = 'ventilator/SET_PROCEDURE_COMPLICATIONS',
  SET_AUTHORIZATION = 'ventilator/SET_AUTHORIZATION',
  SET_COMMENTS = 'ventilator/SET_COMMENTS',
  SET_SIZE = 'ventilator/SET_SIZE',
  SET_ROLE_PERFORMING = 'ventilator/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'ventilator/SET_ROLE_PERFORMING_PNNV',
  SET_ATTEMPTS = 'ventilator/SET_ATTEMPTS',
  SET_SUCCESSFUL_ATTEMPT = 'ventilator/SET_SUCCESSFUL_ATTEMPT',
  GET_PREVIOUS_VENTILATOR_STATE = 'ventilator/GET_PREVIOUS_VENTILATOR_STATE',
}
